import { render, staticRenderFns } from "./QuickNotes.vue?vue&type=template&id=507cdca0&scoped=true&"
import script from "./QuickNotes.vue?vue&type=script&lang=js&"
export * from "./QuickNotes.vue?vue&type=script&lang=js&"
import style0 from "./QuickNotes.vue?vue&type=style&index=0&id=507cdca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cdca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VSlideXTransition,VTextField})
